class AboutUsHeroReveal extends HTMLElement {
  constructor() {
    super();
    this.animation = null;
    this.fallbackTimer = null;
  }

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.showFallback();
      return;
    }

    if (document.readyState === 'complete') {
      this.init();
    } else {
      window.addEventListener('load', () => this.init());
    }

    /* Safety fallback — reveal after 3s only if GSAP never initialises */
    this.fallbackTimer = setTimeout(() => this.showFallback(), 3000);
  }

  getGSAP() {
    if (typeof window !== 'undefined' && window.gsap && typeof window.gsap.to === 'function') {
      return window.gsap;
    }
    if (typeof window !== 'undefined' && window.GSAP && typeof window.GSAP.to === 'function') {
      return window.GSAP;
    }
    if (typeof window !== 'undefined' && window.GreenSockGlobals && window.GreenSockGlobals.gsap) {
      return window.GreenSockGlobals.gsap;
    }
    if (typeof gsap !== 'undefined' && typeof gsap.to === 'function') {
      return gsap;
    }
    return null;
  }

  waitForGSAP() {
    return new Promise((resolve) => {
      if (this.getGSAP()) {
        resolve();
        return;
      }

      /* Poll for GSAP availability — CDN defer scripts may not have executed yet */
      var attempts = 0;
      var check = setInterval(() => {
        attempts++;
        if (this.getGSAP() || attempts > 50) {
          clearInterval(check);
          resolve();
        }
      }, 100);
    });
  }

  async init() {
    await this.waitForGSAP();
    const gsapLib = this.getGSAP();

    if (!gsapLib) {
      this.showFallback();
      return;
    }

    /* GSAP loaded — cancel the safety fallback so it doesn't interfere */
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
      this.fallbackTimer = null;
    }

    var sectionId = this.getAttribute('data-section-id');
    var section = document.getElementById('AboutUsHero-' + sectionId);
    if (!section) return;

    var line1Items = section.querySelectorAll('.about-us-hero__line--1 .about-us-hero__item');
    var line2Items = section.querySelectorAll('.about-us-hero__line--2 .about-us-hero__item');

    var tl = gsapLib.timeline();

    if (line1Items.length) {
      tl.fromTo(line1Items,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.15,
          ease: 'power2.out'
        }
      );
    }

    if (line2Items.length) {
      tl.fromTo(line2Items,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.15,
          ease: 'power2.out'
        },
        line1Items.length ? '-=0.3' : 0
      );
    }

    this.animation = tl;
  }

  showFallback() {
    var sectionId = this.getAttribute('data-section-id');
    var section = document.getElementById('AboutUsHero-' + sectionId);
    if (!section) return;
    var items = section.querySelectorAll('.about-us-hero__item');
    items.forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  disconnectedCallback() {
    if (this.animation && this.animation.kill) {
      this.animation.kill();
    }
  }
}

if (!customElements.get('about-us-hero-reveal')) {
  customElements.define('about-us-hero-reveal', AboutUsHeroReveal);
}

